module.exports = __webpack_public_path__ + "img/u7.c39818f1.jpg";